import { LOGOUT, LOGOUT_SUCCESS } from './types';
import config from 'config';
import localForage from 'localforage';

export default function () {
  return async (dispatch, getState) => {
    await Promise.all([localStorage.clear(), localForage.clear(), dispatch(sendUserLogout(getState().auth)).catch((e) => e)]).catch((e) => e);
    dispatch({ type: LOGOUT_SUCCESS });
    window.location.href = window.location.origin;
  };
}

export const sendUserToLogout = () => {
  return (window.location.href = `${window.location.origin}/logout`);
};

export const sendUserLogout = (stateAuth) => {
  return {
    type: LOGOUT,
    payload: {
      request: {
        baseURL: config.api.baseUrl,
        url: 'user/logout',
        method: 'delete',
        headers: {
          Authorization: 'Bearer ' + stateAuth.accessToken,
          Accept: 'application/json',
        },
      },
    },
  };
};
